<template>
  <div class="our-projects">
    <div class="container-fluid">
      <div>
        <h3 class="mb-3">المشاريع الاستثماريه</h3>
        <div class="locations__header d-flex">
          <div style="flex: 1">
            <el-input
              @input="searchInProjects"
              prefix-icon="el-icon-search"
              placeholder="بحث في المشاريع"
              v-model="search"
            ></el-input>
          </div>
          <div>
            <el-button
              class="babyblue-btn"
              type="primary"
              @click="openAddInvestmentModel = true"
            >
              إضافة
            </el-button>
          </div>
        </div>
        <!-- <div class="mt-2 mb-2 d-flex justify-content-between">
            <div style="flex:1">
                <h2>المشاريع</h2>
            </div>
            <div class="mt-1">
                <el-button @click="openAddInvestmentModel = true">
                    إضافة مشروع
                </el-button>
            </div>
        </div> -->

        <div v-if="projects.length > 0" class="row mt-4">
          <div
            class="col-md-4 mb-5 mt-3"
            v-for="project in projects"
            :key="project.id"
          >
            <div class="single-project" @click="goToLogs(project)">
              <div class="project-icon">
                <img src="@/assets/buildings.jpg" alt="" />
              </div>

              <div class="project-details">
                <h5>{{ project.name }}</h5>
                <span> {{ project.address }} </span>
               

                <div class="locations__actions">
                  
                  <div class="actions mb-0 mt-2">
                    <div>
                      
                      <button @click.stop="editProject(project)">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="Icon"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                        >
                          <rect
                            id="Area"
                            width="20"
                            height="20"
                            fill="#fcfcfc"
                            opacity="0"
                          />
                          <g
                            id="Icon-2"
                            data-name="Icon"
                            transform="translate(1.566 1.566)"
                          >
                            <path
                              id="Path"
                              d="M9.167,3.333H15A1.667,1.667,0,0,1,16.667,5V16.667A1.666,1.666,0,0,1,15,18.333H3.334a1.667,1.667,0,0,1-1.667-1.666V10.833"
                              transform="translate(0.101 -1.566)"
                              fill="none"
                              stroke="#919efa"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                            <path
                              id="Path-2"
                              data-name="Path"
                              d="M9.684,2.083a1.768,1.768,0,0,0-2.5,2.5L15.1,12.5l3.333.833L17.6,10Z"
                              transform="translate(-6.667 -1.566)"
                              fill="none"
                              stroke="#919efa"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                          </g>
                        </svg>
                      </button>
                     
                    </div>

                    <div>
                      <el-popconfirm
                        :title="'هل أنت متأكد من الحذف ؟'"
                        @confirm="deleteProject(project)"
                        :cancel-button-text="'إلغاء'"
                        :confirm-button-text="'حذف'"
                      >
                        <button slot="reference" @click.stop>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="Icon"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                          >
                            <rect
                              id="Area"
                              width="20"
                              height="20"
                              fill="#fcfcfc"
                              opacity="0"
                            />
                            <g
                              id="Icon-2"
                              data-name="Icon"
                              transform="translate(2.5 1.667)"
                            >
                              <path
                                id="Path"
                                d="M17.5,5H2.5"
                                transform="translate(-2.5 -1.667)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <path
                                id="Path-2"
                                data-name="Path"
                                d="M4.167,5V16.667a1.666,1.666,0,0,0,1.666,1.666h8.334a1.666,1.666,0,0,0,1.666-1.666V5m-2.5,0V3.333a1.666,1.666,0,0,0-1.666-1.666H8.333A1.666,1.666,0,0,0,6.667,3.333V5"
                                transform="translate(-2.5 -1.667)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <line
                                id="Line"
                                y2="5"
                                transform="translate(9.167 7.5)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <line
                                id="Line-2"
                                data-name="Line"
                                y2="5"
                                transform="translate(5.833 7.5)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                            </g>
                          </svg>
                        </button>
                      </el-popconfirm>
                    </div>

                      <!-- <span style="margin-right:50%"> {{ project.startedAt }} </span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="no-data-img" v-else>
          <NoData />
        </div>
      </div>
    </div>

    <vs-popup
      class="popup-width-300"
      title="إضافة مشروع جديد"
      :active.sync="openAddInvestmentModel"
    >
      <div class="popup-calender">
        <el-form :model="addInvestment" ref="addInvestment">
        
          <h6 class="mb-1">وصف المشروع</h6>
          <el-form-item prop="name">
            <el-input
              type="text"
              placeholder="الوصف"
              v-model="addInvestment.name"
            ></el-input>
          </el-form-item>

         

          <el-form-item>
            <div>
              <el-button
                class="babyblue-btn"
                type="primary"
                @click="onSubmit('addInvestment')"
              >
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <vs-popup
      class="popup-width-300"
      title="تعديل المشروع"
      :active.sync="editProjectModel"
    >
      <div class="popup-calender">
        <el-form :model="currProject" ref="updateProject">
          <h6 class="mb-1">اسم المشروع</h6>
          <el-form-item
            prop="name"
            :rules="[{ required: true, message: 'الاسم مطلوبة' }]"
          >
            <el-input placeholder="الاسم" v-model="currProject.name"></el-input>
          </el-form-item>

       

          <el-form-item>
            <div>
              <el-button
                type="warning"
                class="babyblue-btn"
                @click="submitEditProject('updateProject')"
              >
                حفظ التعديلات
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import NoData from "@/components/NoData.vue";
import axiosApi from "@/plugins/axios.js";
export default {
  components: {
    NoData,
  },
  created() {
    this.getInvestments();

  },
  data() {
    return {
      search:"",
      projects: [],
      cities: [],
      areas: [],
      openAddInvestmentModel: false,
      addInvestment: {},
      allProjects: [],
      editProjectModel: false,
      currProject: {},
    };
  },
  methods: {
   
    goToLogs(project) {
      // localStorage.setItem('currProject' , JSON.stringify(project));
      this.$router.push(`/investments/${project.id}`);
    },
      editProject(project) {
      this.editProjectModel = true;
      this.currProject = project;
    },
       searchInProjects() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: false,
      //   spinner: "el-icon-loading",
      //   background: "rgba(255,255,255,.7)",
      //   customClass: "fullscreen-loading",
      // });
      this.projects = this.allProjects.filter((ele) => {
        return ele.name.includes(this.search);
      });
      // loading.close();
    },
      deleteProject(currProject){
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .delete(`/investments/${currProject.id}`)
        .then(() => {
          this.$vs.notify({
            title: "تم بنجاح",
            position: "top-center",
            color: "success",
            text: "تم الحذف بنجاح",
          });
          this.getInvestments();
        })
        .catch((err) => {
          if (err.response.status == 500) {
            this.$vs.notify({
              title: " عذرا",
              position: "top-center",
              color: "danger",
              text: "غير مسموح بحذف هذا العنصر",
            });
            return;
          }
            this.$vs.notify({
              title: "حدث خطأ ما",
              position: "top-center",
              color: "danger",
              text: "حدث خطا ما",
            });
        })
        .finally(() => loading.close());
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveProject();
        }
      });
    },
       submitEditProject(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateProject();
        }
      });
    },
    updateProject() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .put(`/investments/${this.currProject.id}`, this.currProject)
        .then(() => {
          this.$vs.notify({
            title: "تم بنجاح",
            position: "top-center",
            color: "success",
            text: "تم التعديل بنجاح",
          });
          this.editProjectModel = false;
          this.currProject = {};
          this.getInvestments();
        })
        .catch((err) => {
          if (err.response.status == 500) {
            this.$vs.notify({
              title: " عذرا",
              position: "top-center",
              color: "danger",
              text: "غير مسموح بحذف هذا العنصر",
            });
          }

          if (err.response.status == 400) {
            this.$vs.notify({
              title: "هذا المشروع موجودة من قبل",
              position: "top-center",
              color: "danger",
              text: "حدث خطا ما",
            });
          }
        })
        .finally(() => loading.close());
    },
    getInvestments() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get("/investments")
        .then((res) => {
          this.projects = res.data;
          this.allProjects = res.data;
        })
        .finally(() => loading.close());
    },
  
    saveProject() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .post("/investments", this.addInvestment)
        .then(() => {
          this.$vs.notify({
            title: "تم بنجاح",
            position: "top-center",
            color: "success",
            text: "تم  حفظ الاستثمار بنجاح",
          });
          this.openAddInvestmentModel = false;
          this.addInvestment = {};
          this.getInvestments();
        })
        .catch((err) => {
          if (err.response.status == 500) {
            this.$vs.notify({
              title: " عذرا",
              position: "top-center",
              color: "danger",
              text: "عفوا من فضلك تاكد من البيانات المطلوبه",
            });
          }

          if (err.response.status == 400) {
            this.$vs.notify({
              title: "هذا المشروع موجودة من قبل",
              position: "top-center",
              color: "danger",
              text: "حدث خطا ما",
            });
          }
        })
        .finally(() => loading.close());
    },
  },
};
</script>

<style lang="scss">
.our-projects {
  padding: 10px;
  .single-project {
    padding: 15px;
    position: relative;
    cursor: pointer;
    box-shadow: 0 4px 25px 0 #0000001a;

    .project-icon {
      text-align: center !important;
      margin: auto;
      img {
        width: 100%;
        height: 229px;
        object-fit: none;
        object-position: center;
        max-width: 352px;
      }
    }

    .project-details {
      position: absolute;
      padding: 18px;
      background: #fff;
      width: 100%;
      box-shadow: 5px -9px 36px 0 #0000001a;
      right: 0;
      border-radius: 13px;
      bottom: -22px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      h5 {
        font-size: 22px;
        font-family: "Cairo";
        margin-bottom: 10px;
      }

      h5 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
